module.exports = __webpack_public_path__ + "img/certificate-back.3716c6f0.png";